import { PropsWithChildren } from 'react';
import { StackProps, VStack } from '@chakra-ui/react';

export function Card({ children, ...props }: PropsWithChildren & StackProps) {
  return (
    <VStack
      width={'100%'}
      align={'flex-start'}
      padding={'20px'}
      backgroundColor={'#FFFFFF'}
      borderRadius="4px"
      boxShadow={'0px 0px 20px rgba(0,0,0,0.06)'}
      {...props}
    >
      {children}
    </VStack>
  );
}
